import React, { useState } from 'react'
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import useStyles from './style';


const SupplementalCommentsViewer = (props) => {
    const { blockState, sideBar, supplementalCommentsInfo } = props;
    const { chartData } = props.data;
    const classes = useStyles();
    const supplementalComments = blockState?.supplementalInformationComments || [];
    const [newComment, setNewComment] = useState('');
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffInMinutes = Math.floor((now - date) / (1000 * 60));

        if (diffInMinutes < 1) return 'Just now';
        if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;

        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours} hours ago`;

        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays} days ago`;
    };

    const handleAddComment = () => {
        if (newComment.trim()) {
            const newCommentObj = {
                comment: newComment.trim(),
                date: new Date().toISOString(),
                by: props.members?.name || supplementalCommentsInfo?.unknownUser
            };

            const updatedComments = [...supplementalComments, newCommentObj];
            const updatedBlockState = {
                ...blockState,
                supplementalInformationComments: updatedComments
            };

            const payloadClone = JSON.parse(JSON.stringify(updatedBlockState));
            props.removeIdFields(payloadClone);

            const formData = {
                appId: props.appId,
                dataModelId: chartData?.selectedDataModel,
                dataUniqueId: props.data.chartUniqueId + '_updateobligation',
                opportunityId: props.match.params.id,
                payload: payloadClone,
            };
            props.updateOpportunity(formData);
            setNewComment('');
        }
    };

    const getInitials = (name) => {
        if (!name) return '?';
        return name
            .split(' ')
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    return (
        <React.Fragment>
            <div style={{ height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'start', boxSizing: 'border-box' }}>
                <div style={{ height: '40px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxSizing: 'border-box' }}>
                        <div style={{ height: '20px', width: '2px', backgroundColor: '#3F51B5' }}>

                        </div>
                        <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#424242', fontStyle: 'normal', lineHeight: '24px' }}>{supplementalCommentsInfo?.title}</Typography>
                    </div>
                </div>
            </div>
            <div className={classes.supplementalWrap}>
                {supplementalComments.length === 0 ? (
                    <div className={classes.emptySupplemental}>
                        {supplementalCommentsInfo?.noSupplementalInfo}
                    </div>
                ) : (
                    supplementalComments.map((comment, index) => (
                        <div key={index} className={classes.commentCard}>
                            <div className={classes.commentHeaderRow}>
                                <Avatar className={classes.commentAvatar}>
                                    {getInitials(comment.by)}
                                </Avatar>
                                <div className={classes.commentMeta}>
                                    <Typography className={classes.commentAuthor}>
                                        {comment.by}
                                    </Typography>
                                    <Typography className={classes.commentDate}>
                                        {formatDate(comment.date)}
                                    </Typography>
                                </div>
                            </div>
                            <div className={classes.commentBodyRow}>
                                <div className={classes.commentBodySpacer} />
                                <Typography className={classes.commentText}>
                                    {comment.comment}
                                </Typography>
                            </div>
                        </div>
                    ))
                )}

                {
                   blockState?.['status'] !== 'Rejected' && blockState?.['status'] !== 'Completed' && (
                        <div className={classes.addCommentRow}>
                            <Avatar className={classes.commentAvatar}>
                                {getInitials(props.members?.name)}
                            </Avatar>

                            <div className={classes.addCommentBox}>
                                <textarea
                                    className={classes.addCommentTextarea}
                                    placeholder={supplementalCommentsInfo?.addSupplementalPlaceholder}
                                    value={newComment}
                                    onChange={(e) => setNewComment(e.target.value)}

                                />
                                <Button
                                    variant="contained"
                                    onClick={handleAddComment}
                                    disabled={!newComment.trim()}
                                    className={`${classes.addCommentButton} ${newComment.trim() ? classes.addCommentButtonActive : classes.addCommentButtonDisabled}`}
                                >
                                    {supplementalCommentsInfo?.addSupplementalInfo}
                                </Button>
                            </div>
                        </div>
                    )
                }

            </div>
        </React.Fragment>
    )
}

export default SupplementalCommentsViewer